import React from 'react';

import { ListProps } from './list.types';
import { CategoriesList } from './categories-list';
import { useCategoriesList } from './use-categories-list';
import { CompactCard } from '../cards/compact-card';

export const CompactList = ({ items, mobileDisplay, style, showHeading }: ListProps): JSX.Element => {
  const { isExpanded, viewAllItems } = useCategoriesList();

  return (
    <CategoriesList
      mobileDisplay={mobileDisplay}
      itemCount={items.length}
      isExpanded={isExpanded}
      viewAllItems={viewAllItems}
      showHeading={showHeading}
    >
      {items.map(({ category, image }, index) => (
        <CompactCard
          key={category}
          category={category}
          image={image}
          radius={style}
          mobileDisplay={mobileDisplay}
          isHidden={!isExpanded && index > 5}
        />
      ))}
    </CategoriesList>
  );
};
